<h2 mat-dialog-title>{{ "FILL_IN_RESPONSE_DIALOG.TITLE" | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{ "FILL_IN_RESPONSE_DIALOG.MESSAGE" | translate }} {{ status }}?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="example-container">
    <mat-form-field>
      <mat-label>{{
        "FILL_IN_RESPONSE_DIALOG.ENTER_YOUR_NOTES" | translate
      }}</mat-label>
      <input
        matInput
        [formControl]="notes"
        [placeholder]="
        'FILL_IN_RESPONSE_DIALOG.ENTER_YOUR_NOTES' | translate
      "
      />
    </mat-form-field>
  </div>
  <button mat-button (click)="onNoClick()">{{
    "FILL_IN_RESPONSE_DIALOG.NO" | translate
  }}</button>
  <button mat-button (click)="onClickOK()" cdkFocusuInitial>{{
    "FILL_IN_RESPONSE_DIALOG.YES" | translate
  }}</button>
</mat-dialog-actions>
